<template>
  <el-card class="project-type" style="margin-bottom:10px;font-size:14px;min-height: 200px;">
    <div class="title">
      <div class="name"><i class="el-icon-s-home" style="font-size: 20px;"></i>项目评分</div>
      <div v-if="project.客户打分" class="handel-btn">
        <el-link :underline="false" type="primary" style="margin-left:10px" @click="openDialog">修改评分</el-link>
      </div>
    </div>
    <div v-if="project.客户打分">
      <div class="level-detail">
        <div class="level-detail-letter">
          <span class="letter">{{ project.客户分类 }}</span> <span>类项目</span>
        </div>
        <div class="desciption-box">
          <p>{{ description[project.客户分类] }}</p>
        </div>
      </div>

      <div class="grade-detail">
        <div v-for="(item, label) in gradeType" :key="label" class="grade-detail-item">
          <el-tooltip placement="top">
            <div slot="content" class="tooltip-content">
              <p v-for="v in item" :key="v">{{ v }}:{{ getGrade([v], project.客户打分明细) }}分</p>
            </div>
            <p>
              <span class="label">{{ label }}:</span>
              <span class="num">{{ getGrade(item, project.客户打分明细) }}分</span>
            </p>
          </el-tooltip>
        </div>
        <div class="grade-detail-count">
          <span class="label">综合评分:</span> <span class="num">{{ getGrade(null, project.客户打分明细) }}分</span>
        </div>
      </div>
      <p v-if="getUnsetFields().length > 0" style="color: #cfcfcf;margin-top: 6px;">
        （{{ getUnsetFields().join('、') }}未填写，建议补全可以让分数更准确）
        <i class="el-icon-edit-outline" style="color:#409EFF;cursor:pointer" @click="openDialog"></i>
      </p>
    </div>
    <div v-else style="padding: 0 50px;">
      <div class="desciption-box">
        <p>项目未评分，请填写评分表</p>
        <div class="edit-icon-box" @click="openDialog"><i class="el-icon-edit-outline"></i> <span>填写评分</span></div>
      </div>
    </div>
    <!-- 填写评分组件 -->
    <ProjectGradeDialog ref="ProjectGradeDialog" @confirm="confirmDialog"></ProjectGradeDialog>
  </el-card>
</template>
<script>
import ProjectGradeDialog from './ProjectGradeDialog'

const obj = {
  公司综合评分: ['公司平台', '公司口碑'],
  职位综合评分: ['职级', '地域', '职位薪酬'],
  职位操作难度: ['业务线', '面试环节', '合理度', '附加维度'],
  数据匹配度: ['数据库', '领域熟悉度'],
  合作价值评分: ['猎头竞争度', '合作模式-费率'],
}
const 评分分类 = {}
for (const field in obj) {
  const arr = obj[field]
  arr.forEach(v => {
    评分分类[v] = field
  })
}
const 评分标准 = {
  公司平台: [
    { label: '大平台', value: '大平台', grade: 10 },
    { label: '中平台', value: '中平台', grade: 5 },
    { label: '小平台', value: '小平台', grade: 0 },
  ],
  公司口碑: [
    { label: '好', value: '好', grade: 8 },
    { label: '中', value: '中', grade: 4 },
    { label: '坏', value: '坏', grade: -4 },
  ],
  职级: [
    { label: 'MD及高管', value: '高管', grade: 5 },
    { label: 'SVP到ED', value: 'SVP到ED', grade: 3 },
    { label: 'AN到VP', value: 'AN到VP', grade: 0 },
  ],
  地域: [
    { label: '北上广深', value: '北上广深', grade: 2 },
    { label: '一线城市', value: '一线', grade: 1 },
    { label: '非一线城市', value: '非一线', grade: -1 },
    { label: '定点一个非一线城市', value: '定点非一线', grade: -2 },
  ],
  职位薪酬: [
    { label: '市场平均75%及以上', value: '75', grade: 10 },
    { label: '市场平均50%', value: '50', grade: 5 },
    { label: '市场平均25及以下', value: '25', grade: -5 },
  ],
  业务线: [
    { label: '能接触到业务直线经理', value: '能', grade: 3 },
    { label: '不能接触到业务直线经理', value: '不能', grade: 0 },
  ],
  面试环节: [
    { label: '面试轮数少于等于2轮', value: '2及以下', grade: 4 },
    { label: '面试3轮及以上', value: '2以上', grade: 2 },
  ],
  合理度: [
    { label: '客户要求高，很挑剔', value: '高', grade: -10 },
    { label: '客户要求较高，有一定合理度', value: '较高', grade: 5 },
    { label: '客户要求合理，刚需', value: '合理', grade: 10 },
  ],
  附加维度: [
    { label: '6个月保证期', value: '保证期', grade: -3 },
    { label: '有离职退款条款', value: '离职条款', grade: -3 },
    { label: '预付费条款', value: '预付费条款', grade: 3 },
  ],
  数据库: [
    { label: '数据库支持5天内找到', value: '5天内', grade: 10 },
    { label: '数据库支持10天内找到', value: '10天内', grade: 5 },
    { label: '无相关数据', value: '无数据', grade: -5 },
  ],
  领域熟悉度: [
    { label: '在你的熟悉领域&可以和其他职位一起做', value: '熟悉', grade: 10 },
    { label: '非熟悉领域', value: '非熟悉', grade: 5 },
  ],
  猎头竞争度: [
    { label: '独家职位', value: '独家', grade: 15 },
    { label: '有其他猎头，但竞争度不强', value: '竞争不强', grade: 10 },
    { label: '有多家猎头竞争', value: '多家竞争', grade: -5 },
    { label: '多家猎头竞争，开始很久了', value: '竞争已久', grade: -10 },
  ],
  '合作模式-费率': [
    { label: '25%以上费率', value: '高', grade: 10 },
    { label: '24%及以下费率', value: '中', grade: 5 },
    { label: '20%及以下费率', value: '低', grade: -5 },
  ],
}
const 多选 = ['附加维度']
const defaultGrade = {}
for (const v in 评分标准) {
  defaultGrade[v] = []
}
// gradeMap
const gradeMap = {}
for (const field in 评分标准) {
  const arr = 评分标准[field]
  arr.forEach(v => {
    gradeMap[`${field}${v.value}`] = v.grade
  })
}

const companyFields = ['公司平台', '公司口碑', '合理度', '附加维度', '猎头竞争度', '合作模式-费率']
const projectFields = ['职级', '地域', '职位薪酬', '业务线', '面试环节', '数据库', '领域熟悉度']

export default {
  components: { ProjectGradeDialog },
  props: {
    project: { type: Object, default: () => ({}) },
    company: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      dialogVisible: false,
      keys: ['平台及岗位', '匹配度', '操作难度', '合作模式'],
      gradeType: obj,
      gradeitem2type: 评分分类,
      gradeStandard: 评分标准,
      gradeMap: gradeMap,
      mulItem: 多选,
      grade: defaultGrade,
      description: {
        'A+': '金主爸爸',
        A: '需全力以赴的职位',
        B: '为保证成单，需要安排出核心时间、发掘资源来做',
        C: '更建议快速联系自己直接能touch到的数据库人选，不做额外搜寻',
        D: '顺手做的单子/直接拒掉',
      },
    }
  },
  methods: {
    openDialog() {
      this.$refs.ProjectGradeDialog && this.$refs.ProjectGradeDialog.open(this.project, this.company)
    },
    closeDialog() {
      this.$refs.ProjectGradeDialog && this.$refs.ProjectGradeDialog.parentClose()
    },
    getUnsetFields() {
      const grade = this.project.客户打分明细 || defaultGrade
      const arr = []
      projectFields.forEach(field => {
        if (!grade[field] || grade[field].length === 0) arr.push(field)
      })
      return arr
    },
    getGrade(val, theGrade) {
      const { grade, gradeStandard, gradeMap } = this
      const fields = val || Object.keys(gradeStandard)
      const useGrade = theGrade || grade
      let num = 0
      fields.forEach(field => {
        const arr = useGrade[field]
        arr.forEach(v => {
          num += gradeMap[`${field}${v}`]
        })
      })
      return num
    },
    async confirmDialog(option) {
      try {
        await app.service('project').modify({ id: this.project._id, param: option })
        for (const key in option) {
          this.$set(this.project, key, option[key])
        }
        this.closeDialog()
      } catch (e) {
        this.$message.error(`update project :${e.message}`)
      }
    },
  },
}
</script>
<style>
.project-grade-dialog .el-dialog__body {
  padding-top: 0px;
}
.grade-checkbox-2,
.grade-checkbox-3,
.grade-checkbox-4 {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  flex-grow: 1;
}
.grade-checkbox-2 {
  justify-content: start;
}
.grade-checkbox-4 {
  justify-content: start;
}
.question-item .grade-checkbox-2 .el-checkbox {
  min-width: 40%;
}
.question-item .grade-checkbox-3 .el-checkbox {
  min-width: 33%;
  margin-right: 0;
}
.question-item .grade-checkbox-4 .el-checkbox {
  min-width: 33%;
  margin-right: 0;
}
</style>
<style scoped>
.desciption-box {
  border: 1px solid #e4e4e4;
  border-radius: 4px;
  padding: 4px 10px;
  display: flex;
}
.edit-icon-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #409eff;
  width: 60px;
  margin-left: 20px;
  cursor: pointer;
}
.title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 10px;
  font-weight: 300;
  margin-right: 4px;
  line-height: 26px;
}
.title .name {
  font-size: 18px;
  font-weight: 700;
}
.question-type {
  padding: 4px 0;
  border-top: 1px solid #eee;
}
.question-type-label {
  color: #666666;
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 14px;
}
.question-item {
  display: flex;
  margin-bottom: 8px;
}
.question-title {
  width: 110px;
  flex: none;
  text-align: center;
  color: #999;
}
.level-detail {
  display: flex;
}
.level-detail-letter {
  width: 110px;
  flex: none;
  height: 51px;
  margin-right: 30px;
}
.level-detail .desciption-box {
  flex-grow: 1;
  align-self: center;
}
.letter {
  font-size: 40px;
  color: #ff9900;
  margin-right: 10px;
}
.grade-detail {
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 10px 19px;
  display: flex;
  flex-wrap: wrap;
}
.grade-detail-item,
.grade-detail-count {
  width: 50%;
  margin-bottom: 4px;
  display: flex;
  padding: 5px;
  border-radius: 4px;
}
.grade-detail .label {
  width: 90px;
  flex: none;
  display: inline-block;
}
.grade-detail .num {
  font-weight: 700;
  margin-left: 10px;
}
.grade-detail-count {
  background-color: #eee;
}
</style>
